module.exports = __webpack_public_path__ + "img/shareLinkWhite.7e53b79e.svg";